// Tracks the order in which modals are opened so that pressing ESC
// only closes the topmost modal. Each UIModal instance calls this once
// and gets its own unique ID to register and check its position.
const openModalStack = [];

export const useModalStack = () => {
  const modalId = Symbol();

  const registerModal = () => openModalStack.push(modalId);

  const unregisterModal = () => {
    const index = openModalStack.lastIndexOf(modalId);
    if (index !== -1) openModalStack.splice(index, 1);
  };

  const isTopmostModal = () => {
    const topOfStack = openModalStack[openModalStack.length - 1];
    return openModalStack.length > 0 && topOfStack === modalId;
  };

  return { registerModal, unregisterModal, isTopmostModal };
};
